import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { clearEmptyProperties } from '@core/utils/filters-utils';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';

import english from '../i18n/en.json';
import spanish from '../i18n/pt.json';
import portuguese from '../i18n/pt.json';

@Component({
  selector: 'filters-segments',
  templateUrl: './filters.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class FiltersComponent implements OnInit {

  filtersForm: FormGroup;

  public filterChanged = new BehaviorSubject<any>({ archived: false });

  constructor(
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
    private formBuilder: FormBuilder,

  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  async ngOnInit(): Promise<void> {

    this.filtersForm = this.formBuilder.group({
      name: null,
      archived: false,
    });

    this.filtersForm.valueChanges.pipe(
      debounceTime(500),
      tap(() => {
        const filters = clearEmptyProperties({
          name_contains: this.filtersForm.value.name,
          archived: this.filtersForm.value.archived
        });
        this.filterChanged.next(filters);
      })
    ).subscribe();
  }

  clearFilters(): void {
    this.filtersForm.patchValue({
      name: null,
      archived: false
    });
  }
}
